const DOM = {};

const cacheDOM = () => {
    DOM.vacancies = document.querySelector('.vacancies');
    DOM.showMoreBtn = document.querySelector('.vacancies__button');
    DOM.vacancyList = document.querySelector('.vacancies__list');
    DOM.vacancyItems = document.querySelectorAll('.vacancies__item');
};

const loadMore = () => {
    const startIndex = DOM.vacancyItems.length;

    DOM.showMoreBtn.setAttribute('disabled', 'true');

    fetch(`/umbraco/surface/loadmore/getvacancies?startIndex=${startIndex}`)
        .then((res) => res.json())
        .then((json) => {
            DOM.vacancyList.innerHTML += json.html;
            if (json.remaining === false) {
                DOM.showMoreBtn.classList.add('vacancies__button--inactive');
            }

            DOM.vacancyItems = document.querySelectorAll('.vacancies__item');
            DOM.showMoreBtn.removeAttribute('disabled');
        });
};

const bindEvents = () => {
    DOM.showMoreBtn.addEventListener('click', loadMore);
};

const init = () => {
    cacheDOM();
    if (DOM.vacancies) {
        bindEvents();
    }
};

const vacancies = { init };
export default vacancies;
